module.exports = __webpack_public_path__ + "assets/sinEjeY.b1fd95c00e7e1cb3382450156a110976.svg";


//////////////////
// WEBPACK FOOTER
// ./img/sinEjeY.svg
// module id = 916
// module chunks = 0